import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform<T>(value: T[], key: keyof T, check: boolean = true): T[] {
    return value.filter((item) => item[key] === check);
  }
}
